var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterCenters({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2069 8.70672C16.0345 8.70672 15.9482 8.62073 15.7758 8.62073C14.7413 8.62073 13.8793 9.48065 13.8793 10.5125C13.8793 10.6845 13.8793 10.8565 13.9655 10.9425L13.8793 11.0285L10.1724 14.7262C9.99997 14.6402 9.82756 14.6402 9.65514 14.6402C8.62066 14.6402 7.75859 15.5001 7.75859 16.532C7.75859 17.5639 8.62066 18.4238 9.65514 18.4238C10.6896 18.4238 11.5517 17.5639 11.5517 16.532C11.5517 16.36 11.5517 16.274 11.5517 16.188L15.3448 12.4044L15.431 12.3184C15.6034 12.3184 15.6896 12.4044 15.862 12.4044C16.8965 12.4044 17.7586 11.5445 17.7586 10.5125C17.7586 10.3406 17.7586 10.1686 17.6724 9.9966L16.5517 11.2005L15.431 10.8565L15.0862 9.82461L16.2069 8.70672Z",
    stroke: "#003087",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5693 11.7165L10.8624 15.4141",
    stroke: "#003087",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0864 15.8441H9.1381L8.70706 16.618L9.1381 17.3919H10.0864L10.5174 16.618L10.0864 15.8441Z",
    stroke: "#003087",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1207 12.7483L9.05169 10.6845L8.53445 10.5985L7.75859 9.30866L8.44825 8.62073L9.65514 9.30866L9.82756 9.91061L11.8103 11.8884",
    stroke: "#003087",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.776 18.2518L13.5346 16.102C13.8795 15.7581 13.3622 15.1561 13.0174 15.5001L12.5863 15.0701",
    stroke: "#003087",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5518 17.3919L15.776 18.2518",
    stroke: "#003087",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3276 16.618L15.1724 14.4682C14.8276 14.8122 14.2241 14.2962 14.569 13.9522L14.1379 13.5223",
    stroke: "#003087",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5519 17.4779L17.4139 16.618",
    stroke: "#003087",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1829 15L14 15.1824L15.6458 16.8242L15.8287 16.6418L14.1829 15Z",
    fill: "#003087"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.776 18.2518C15.9484 18.5098 16.2932 18.5958 16.638 18.5958C17.2415 18.5958 17.7587 18.0798 17.7587 17.4779C17.7587 17.1339 17.5863 16.79 17.3277 16.618",
    stroke: "#003087",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4896 2.93754L3.27085 8.71878C2.45835 9.36461 1.93751 10.7292 2.11459 11.7501L3.50001 20.0417C3.75001 21.5209 5.16667 22.7188 6.66667 22.7188H18.3334C19.8229 22.7188 21.25 21.5104 21.5 20.0417L22.8854 11.7501C23.0521 10.7292 22.5313 9.36461 21.7292 8.71878L14.5104 2.94797C13.3958 2.05213 11.5938 2.05212 10.4896 2.93754Z",
    stroke: "#003087",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterCenters);
export default __webpack_public_path__ + "static/media/footer-centers.bfab3336.svg";
export { ForwardRef as ReactComponent };